const GraphConfig = {
    graphWidth: null,
    graphHeight: null,
    containerName: 'graph',
    leftButtonForPanning: true,
    newElementName: 'New Element',
    newElementSummary: 'New Element'
};

export default GraphConfig;